module.exports = __webpack_public_path__ + "static/media/Pat and.bd02e111.jpg";